import { render } from "./ScrollToTopButton.vue?vue&type=template&id=6f68c486"
import script from "./ScrollToTopButton.vue?vue&type=script&lang=js"
export * from "./ScrollToTopButton.vue?vue&type=script&lang=js"

import "./ScrollToTopButton.vue?vue&type=style&index=0&id=6f68c486&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__